<template>
    <div style="height: 70vh;" uk-grid>
        <div class="uk-width-auto">
            <v-btn>Info</v-btn>
            <v-btn>Folders</v-btn>
        </div>
        <div class="uk-width-expand" style="background-color: #00000022">
            <v-icon class="uk-align-right">mdi-clock</v-icon>
            <v-btn class="uk-align-right">
                <v-icon >mdi-folder</v-icon>
                Historic Folder A
            </v-btn>

            <v-btn class="uk-align-right">
                <v-icon >mdi-folder</v-icon>
                Historic Folder B
            </v-btn>

        </div>
        <div class="uk-width-1-1">
            <h3>Invoice Folders</h3>
            <div>

            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "InvoiceFilesManager",
        props:{
            selected_invoice: Object
        },
        data: () => ({
            title: "Store",

            process_folders: {},
            process_categories: {},

            items: [],
            file_groups: undefined,
            files: undefined
        }),
        created (){

            this.getFolderInfo();
            // //Get all file_groups and files from the selected invoice
            // this.$http.get(this.$http.defaults.baseURL + '/invoice/process-folder')
            //     .then(data => {
            //         console.log(data.data);
            //         this.process_folders = data.data;
            //     })
        },
        watch:{
            selected_invoice: function () {
                //Load all file_groups and files of the selected invoice per folder
            }
        },
        methods:{
            getFolderInfo: async () => {
                let data = await Promise.all([
                            axios.get(axios.defaults.baseURL + '/invoice/process-folder/categories'),
                            axios.get(axios.defaults.baseURL + '/invoice/process-folder')
                                            ]);

                console.log(data);

                this.process_folders = data[1];
                this.process_categories = data[0];




            },

        },

    }
</script>

<style scoped>

</style>
